import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { destroyTimelineStrategist, destroyTimelineStage} from '../../../../actions/projectTimelineActions'
// import { resendInvitationStrategistByUser } from '../../../../actions/projectTimelineActions'
import StrategyForm from './StrategyForm'
import UpdateStageForm from './UpdateStageForm'
import { Modal } from 'react-bootstrap';
import StageTable from './StageTable'
import StrategistTable from './StrategistTable';

const Timeline = (props) => {

    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth)

    const [members, setMembers] = useState([]);
    const [formVisibleMode, setFormVisibleMode] = useState(false);
    const [deleteProfileModal, setDeleteProfileModal] = useState(false)
    const [timelineDelete, setTimelineDelete] = useState()
    // const [inputID, setInputID] = useState("");
    const [stageList, setStageList] = useState([]);
    const [inputProjectId, setInputProjectId] = useState("");
    const [isStrategyOwner, setIsStrategyOwner] = useState('');
    const [inputStrategyOwnerId, setInputStrategyOwnerId] = useState('');
    const [inputProjectClientId, setInputProjectClientId] = useState("");
    const [inputProjectPartners, setInputProjectPartners] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(false);
    // const [isOwner, setIsOwner] = useState(false);
    const [isClientPartner, setIsClientPartner] = useState(false);
    // const [isRejected, setIsRejected] = useState(false);
    const [inputEdit, setInputEdit] = useState("")


    useEffect(() => {
        // console.log(props.timelines, 'data ')
        if (props.data) {
            setInputProjectId(props.data?.id)
            setInputProjectClientId(props.data?.client_id)
            setInputProjectPartners(props?.data?.partners || [])
            setStageList(props?.timelines)
            const results = props?.members?.filter(({ id: id1 }) => 
            !props?.timelines?.strategist?.some(({ strategist_user_id: id2 }) =>
            id2 === id1
            ));
            let checkCurrentStrategist = props?.timelines?.strategist?.find(function (item) {
                return item.strategist_user_id === user.user_id && item.is_accepted;
            });
            setInputStrategyOwnerId(checkCurrentStrategist?.strategist_user_id)

            // console.log( checkCurrentStrategist , 'checkCurrentStrategist ')
            setMembers(results)
        }
    }, [props.data, props.members, props?.timelines, user]);

    useEffect(() => {
        if (inputProjectPartners) {
            var isPartners
            inputProjectPartners?.find(function (value) {
                if (value.id === user.user_id) return isPartners = value;
                return isPartners;
            });

            if (inputProjectClientId === user.user_id || isPartners) {
                // console.log(inputProjectClientId === user.user_id)
                return setIsClientPartner(true)
            }
        }
        if (inputStrategyOwnerId === user.user_id) {
            setFormVisibleMode(true)
            setIsStrategyOwner(true)
        }
    }, [inputProjectPartners, user, inputStrategyOwnerId, inputProjectClientId])

    const handdelUpdate = (data) => {
        setSelectedRowData(data);
        setInputEdit("edit");
        setFormVisibleMode(true);
    }
    const handelCreateTimeline = () => {
        setSelectedRowData(false);
        setInputEdit("add");
        setFormVisibleMode(true);
    }
    const deleteTimelineModalShow = (data, type) => {
        // console.log(data, type)
        const formDataDelete = {
            project_id: inputProjectId,
            type: type
        }
        type === 'Strategist' ? formDataDelete.id =   data.strategist_user_id : formDataDelete.id =   data.id;
        setTimelineDelete(formDataDelete)
        setDeleteProfileModal(true)
    }
    const deleteStrategyModalClose = () => {
        setDeleteProfileModal(false)
        setTimelineDelete()
    }
    const handleDeleteTimelineSubmit = () => {
        timelineDelete.type === 'Strategist' ? dispatch(destroyTimelineStrategist(timelineDelete)) : dispatch(destroyTimelineStage(timelineDelete));
        setDeleteProfileModal(false)
        setTimelineDelete()
    }
    // const onResendInvite = (id) => {
    //     // dispatch(resendInvitationStrategistByUser({id: id.toString(), project_id: inputProjectId.toString()}))
    // }
    const handleStateFormClose = () => {
        setFormVisibleMode(false);
        setSelectedRowData(false);
    };
    return (
        <>
            <div className="row clearfix">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    <div className="card card-radius">
                        <div className="header card-header custum-bg-warning rounded">
                            <h2 className="text-white">Timeline</h2>
                            {isStrategyOwner ? <span className="header-dropdown dropdown dropdown-animated scale-left text-white" onClick={() => handelCreateTimeline()}><i className='fa fa-plus-circle fa-lg'></i></span> : null}
                        </div>
                        <div className="body card-body-shadow">
                            {isClientPartner ? !isStrategyOwner ? <StrategyForm members={members} data={props?.data} /> : null :
                                //    formVisibleMode ? 
                                <UpdateStageForm
                                    members={props?.members}
                                    data={props?.data}
                                    strategistId={inputStrategyOwnerId}
                                    timeline={selectedRowData}
                                    open={formVisibleMode}
                                    mode={inputEdit}
                                    close={handleStateFormClose}
                                    onLoad={props?.members}
                                />
                                //  :  null
                            }
                            <div className="table-responsive">
                                { isClientPartner ? <>
                                    <StrategistTable isClientPartner={isClientPartner} deleteTimelineModalShow={deleteTimelineModalShow} strategist={stageList.strategist} />
                                    <StageTable stages={stageList.stages} deleteTimelineModalShow={deleteTimelineModalShow} handdelUpdate={handdelUpdate} /></>
                                    :
                                    <StageTable stages={stageList.stages} deleteTimelineModalShow={deleteTimelineModalShow} handdelUpdate={handdelUpdate} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Modal show={deleteProfileModal} onHide={deleteStrategyModalClose} className="modal fade modal-bx-info" id="exampleModalLong" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                    <div className="modal-dialog  m-0" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-danger">Delete Timeline From Server</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={deleteStrategyModalClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                Are you sure to delete?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handleDeleteTimelineSubmit}>Confirm</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={deleteStrategyModalClose}>Close</button>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
};
export default Timeline;